// extracted by mini-css-extract-plugin
export default {"root":"CardHeader_root__5Xh1Z","title":"CardHeader_title__3k7QI","content":"CardHeader_content__7sBHp"};